function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/****************************************************************
 *
 * An extension of the Game Engine for special games like
 * Poker or Blackjack where you want to start a game with
 * 2 players, but have open slots on the table that other
 * players can join at a later time. Meanwhile, players can
 * stop playing without ending the game
 *
 *
 ***************************************************************/

var Transaction = require('../../lib/saito/transaction')["default"];
var GameTemplate = require('./gametemplate');
var SaitoOverlay = require('./../saito/ui/saito-overlay/saito-overlay');
var GameTableTemplate = /*#__PURE__*/function (_GameTemplate) {
  function GameTableTemplate(app) {
    var _this;
    _classCallCheck(this, GameTableTemplate);
    _this = _callSuper(this, GameTableTemplate, [app]);
    _this.can_bet = 1;
    _this.crypto_msg = 'settles round-by-round';
    _this.opengame = true;
    //
    // We will use this as a flag for Arcade to distinguish between parent and child class
    // players still need to select 'open-game' through the Arcade game wizard to fully realize
    // differential behavior
    //

    _this.toJoin = [];
    _this.toLeave = [];
    _this.joining = {};
    _this.leaving = {};
    _this.statistical_unit = 'hand';
    _this.resetCommand = 'newround';
    _this.exitOverlay = new SaitoOverlay(app, _this, false);
    return _this;
  }
  _inherits(GameTableTemplate, _GameTemplate);
  return _createClass(GameTableTemplate, [{
    key: "initializeGame",
    value: function initializeGame() {
      _superPropGet(GameTableTemplate, "initializeGame", this, 3)([]);
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.game.options['open-table']) {
                console.info('GTT: Treat table game as standard (closed) game');
                this.opengame = false;
              }
              _context.n = 1;
              return _superPropGet(GameTableTemplate, "render", this, 3)([app]);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }() // Extension for table games
  }, {
    key: "receiveMetaMessage",
    value: function () {
      var _receiveMetaMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tx) {
        var txmsg, auths, data, pkey, i, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!tx.isTo(this.publicKey)) {
                console.warn("GTT: processing a tx that isn't addressed to us...");
              }
              txmsg = tx.returnMessage();
              if (!(txmsg.request == 'JOIN')) {
                _context2.n = 3;
                break;
              }
              auths = 0;
              data = txmsg.data;
              pkey = data.pkey; // Temporary storage here
              if (!this.joining[pkey]) {
                this.joining[pkey] = data;
              }

              //
              // But update with each incoming confirmation
              //
              for (i = 0; i < data.sigs.length; i++) {
                if (data.sigs[i]) {
                  auths++;
                  this.joining[pkey].sigs[i] = data.sigs[i];
                }
              }
              this.joining[pkey].round = Math.max(data.round, this.joining[pkey].round);

              // I am a player, need to confirm...
              if (!this.game.player) {
                _context2.n = 2;
                break;
              }
              if (data.sigs[this.game.player - 1]) {
                _context2.n = 2;
                break;
              }
              _t = this.app.crypto;
              _t2 = "ADDPLAYER ".concat(data.pkey);
              _context2.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              this.joining[pkey].sigs[this.game.player - 1] = _t.signMessage.call(_t, _t2, _context2.v);
              this.joining[pkey].round = Math.max(data.round, this.currentRound());
              this.sendMetaMessage('JOIN', this.joining[pkey]);
              return _context2.a(2);
            case 2:
              if (auths == this.game.players.length) {
                if (!this.toJoin.includes(pkey)) {
                  if (this.currentRound() >= this.joining[pkey].round) {
                    this.toJoin.push(pkey);
                    siteMessage("".concat(this.publicKey == pkey ? 'You' : this.app.keychain.returnUsername(pkey), " will be dealt in next hand"), 2500);
                  } else {
                    console.warn("GTT: Don't add player because other players have already started next round!");
                  }
                }
                console.debug('GTT: JOIN SUCCESS:', JSON.parse(JSON.stringify(this.toJoin)), JSON.parse(JSON.stringify(this.joining)));
              }
              return _context2.a(2);
            case 3:
              if (!(txmsg.request == 'LEAVE')) {
                _context2.n = 4;
                break;
              }
              console.info('GTT: Leave request:' + txmsg.my_key);
              if (!this.toLeave.includes(txmsg.my_key)) {
                this.toLeave.push(txmsg.my_key);
                siteMessage("".concat(this.publicKey == txmsg.my_key ? 'You' : this.app.keychain.returnUsername(txmsg.my_key), " will leave the table after this hand"), 2500);
              }
              return _context2.a(2);
            case 4:
              if (!(txmsg.request == 'CANCEL')) {
                _context2.n = 5;
                break;
              }
              this.toJoin = this.toJoin.filter(function (key) {
                return key !== txmsg.my_key;
              });
              this.toLeave = this.toLeave.filter(function (key) {
                return key !== txmsg.my_key;
              });
              siteMessage("".concat(this.app.keychain.returnUsername(txmsg.my_key), " changed their mind"), 2500);
              return _context2.a(2);
            case 5:
              if (!(txmsg.request == 'SETTLEMENT')) {
                _context2.n = 6;
                break;
              }
              console.info("GTT: ".concat(tx.from[0].publicKey, " requested we settle at the end of the round"));
              this.settleNow = true;
              siteMessage('Will settle at the end of the round', 1500);
              return _context2.a(2);
            case 6:
              _superPropGet(GameTableTemplate, "receiveMetaMessage", this, 3)([tx]);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function receiveMetaMessage(_x2) {
        return _receiveMetaMessage.apply(this, arguments);
      }
      return receiveMetaMessage;
    }()
  }, {
    key: "syncPlayerJoins",
    value: function syncPlayerJoins() {
      for (var pkey in this.joining) {
        if (!this.toJoin.includes(pkey)) {
          if (this.currentRound() >= this.joining[pkey].round) {
            var auths = 0;
            for (var i = 0; i < this.joining[pkey].sigs.length; i++) {
              if (this.joining[pkey].sigs[i]) {
                auths++;
              }
            }
            if (auths == this.game.players.length) {
              this.toJoin.push(pkey);
              siteMessage("".concat(this.publicKey == pkey ? 'You' : this.app.keychain.returnUsername(pkey), " will be dealt in next hand"), 2500);
            } else {
              console.warn('GTT: Still missing a confirmation...');
            }
          } else {
            console.warn("GTT: Don't add player because other players have already started next round!");
          }
        }
      }
    }
  }, {
    key: "addPlayerLate",
    value: function addPlayerLate(address) {
      if (!this.addPlayer(address)) {
        return;
      }
      //To add a player after the game started,
      // need to assign this.game.player
      // add key
      if (this.publicKey === address) {
        this.game.player = this.game.players.length;
      }
      this.game.keys.push(address);
    }
  }, {
    key: "addPlayerToState",
    value: function addPlayerToState(address) {
      console.error('GTT: Did you define addPlayerToState in your game module?');
    }
  }, {
    key: "refreshPlayerboxes",
    value: function refreshPlayerboxes() {
      console.error('GTT: Did you define refreshPlayerboxes in your game module?');
    }
  }, {
    key: "receiveStopGameTransaction",
    value: function () {
      var _receiveStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resigning_player, txmsg) {
        var i;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.game.players.length == 2)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return _superPropGet(GameTableTemplate, "receiveStopGameTransaction", this, 3)([resigning_player, txmsg]);
            case 1:
              return _context3.a(2);
            case 2:
              if (this.publicKey === resigning_player) {
                this.game.over = 2;
                this.saveGame(this.game.id);
              }

              //Stop receiving game txs
              if (this.game.players.includes(resigning_player)) {
                _context3.n = 3;
                break;
              }
              //Player already not an active player, make sure they are also removed from accepted to stop receiving messages
              for (i = this.game.accepted.length; i >= 0; i--) {
                if (this.game.accepted[i] == resigning_player) {
                  this.game.accepted.splice(i, 1);
                }
              }
              console.warn("GTT: ".concat(resigning_player, " not in ").concat(JSON.stringify(this.game.players)));
              this.saveGame(this.game.id);
              return _context3.a(2);
            case 3:
              //Schedule to leave at end of round
              if (!this.toLeave.includes(resigning_player)) {
                this.toLeave.push(resigning_player);
              }
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function receiveStopGameTransaction(_x3, _x4) {
        return _receiveStopGameTransaction.apply(this, arguments);
      }
      return receiveStopGameTransaction;
    }() //
    // Overwrite gametemplate-web3 function because these games are more complicated
    // Todo: check that there is no remaining debt
    //
  }, {
    key: "settleGameStake",
    value: function settleGameStake(winners) {
      if (_typeof(this.game.stake) == 'object') {
        console.debug('GTT [settleGameStake]: use standard end game log for asymmetrical winner-take-all');
        _superPropGet(GameTableTemplate, "settleGameStake", this, 3)([winners]);
      } else {
        this.settleDebt();
      }
      return;
    }
  }, {
    key: "resetGameWithFewerPlayers",
    value: function resetGameWithFewerPlayers() {
      var _this2 = this;
      console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!! GAME UPDATED !!!\n', '!!!!!!!!!!!!!!!!!!!!');
      console.log('My Public Key: ' + this.publicKey);
      console.log('My Position: ' + this.game.player);
      console.log('ALL PLAYERS: ' + JSON.stringify(this.game.players));
      console.log('ALL KEYS: ' + JSON.stringify(this.game.keys));
      console.log('saving with id: ' + this.game.id);
      console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n');
      this.game.queue = [this.resetCommand];
      this.game.live = true;
      this.saveGame(this.game.id);
      setTimeout(function () {
        console.info('Re-initialize game with different players');
        _this2.initialize_game_run = 0;
        _this2.halted = 0;
        _this2.refreshPlayerboxes();
        _this2.initializeGameQueue(_this2.game.id);
      }, 1000);
    }
  }, {
    key: "exitConfirmationTemplate",
    value: function exitConfirmationTemplate() {
      return "<div class=\"saito-modal saito-modal-menu game-exit-menu\" id=\"saito-exit-menu\">\n            <div class=\"saito-modal-title\">Exit Game / Leave Table</div>\n            <div class=\"saito-modal-content saito-menu-select-heavy\">\n              <div class=\"saito-modal-menu-option\" id=\"stay\">\n                <i class=\"fa-solid fa-play\"></i>\n                <div class=\"option-keyword\">Continue playing</div>\n              </div>\n              <div class=\"saito-modal-menu-option\" id=\"finish\">\n                <i class=\"fa-solid fa-forward-step\"></i>\n                <div class=\"option-keyword\">Finish Hand<span>--</span><span class=\"option-explanation\">play out the hand and then leave</span></div>\n              </div>\n              <div class=\"saito-modal-menu-option\" id=\"forfeit\">\n                <i class=\"fa-solid fa-door-open\"></i>\n                <div class=\"option-keyword\">Leave now<span>--</span><span class=\"option-explanation\">abandon any active bets and quit the game</span></div>\n              </div>\n            </div>\n          </div>";
    }
  }, {
    key: "exitGame",
    value: function () {
      var _exitGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var game_self;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (this.game.over == 0 && this.game.player && this.game.options['open-table']) {
                //this.game.state.passed[loser - 1] = 1;

                this.exitOverlay.show(this.exitConfirmationTemplate());
                this.exitOverlay.blockClose();
                game_self = this;
                $('.saito-modal-menu-option').off();
                $('.saito-modal-menu-option').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  var choice;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        choice = $(this).attr('id');
                        game_self.exitOverlay.remove();
                        if (!(choice == 'stay')) {
                          _context4.n = 1;
                          break;
                        }
                        return _context4.a(2);
                      case 1:
                        if (!(choice == 'forfeit')) {
                          _context4.n = 3;
                          break;
                        }
                        _context4.n = 2;
                        return game_self.sendStopGameTransaction('withdraw');
                      case 2:
                        game_self.game.over = 2;
                        game_self.removePlayer(game_self.publicKey);
                        game_self.saveGame(game_self.game.id);
                        setTimeout(function () {
                          //Recursive but will call super because changed the flag
                          game_self.exitGame();
                        }, 500);
                      case 3:
                        if (choice == 'finish') {
                          game_self.sendMetaMessage('LEAVE');
                        }
                      case 4:
                        return _context4.a(2);
                    }
                  }, _callee4, this);
                })));
              } else {
                _superPropGet(GameTableTemplate, "exitGame", this, 3)([]);
              }
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function exitGame() {
        return _exitGame.apply(this, arguments);
      }
      return exitGame;
    }()
    /**
     * Definition of core gaming logic commands
     */
  }, {
    key: "initializeQueueCommands",
    value: function initializeQueueCommands() {
      var _this3 = this;
      //Take all Game Engine Commands
      _superPropGet(GameTableTemplate, "initializeQueueCommands", this, 3)([]);
      this.commands.unshift(function (game_self, gmv) {
        if (gmv[0] === _this3.resetCommand) {
          if (_this3.game.player) {
            _this3.cacheGame = JSON.parse(JSON.stringify(_this3.game));
            //clear out cards
            _this3.cacheGame.deck = [];
            _this3.cacheGame.pool = [];
            console.info('GTT: Save game state...', _this3.cacheGame);
          }
        }
        return 1;
      });

      //Add some more ones
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'ADDPLAYER') {
          var pkey = gmv[1];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          console.info('GTT: Adding ' + pkey + ' to game');
          _this3.addPlayerLate(pkey); // Adds player to game
          _this3.addPlayerToState(pkey);
          _this3.updateLog('================');
          _this3.updateLog("".concat(_this3.app.keychain.returnUsername(pkey), " joins the table as Player ").concat(_this3.game.players.length));
          if (pkey === _this3.publicKey) {
            _this3.app.connection.emit('arcade-gametable-addplayer', _this3.game.id);
          }

          // Clear toJoin
          for (var j = _this3.toJoin.length - 1; j >= 0; j--) {
            if (_this3.toJoin[j] == pkey) {
              _this3.toJoin.splice(j, 1);
            }
          }
          delete _this3.joining[pkey];
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'REMOVEPLAYER') {
          var pkey = gmv[1];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          console.info('GTT: Removing ' + pkey + ' from game');
          var i = _this3.game.players.indexOf(pkey);
          _this3.updateLog("Player ".concat(i + 1, " (").concat(_this3.app.keychain.returnUsername(pkey), ") leaves the table."));
          _this3.removePlayer(pkey);
          if (pkey == _this3.publicKey) {
            _this3.updateStatusForPlayerOut('You cashed out of the table game');
          }
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'RESTARTGAME') {
          _this3.toLeave = [];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          if (game_self.game.players.length === 1) {
            _this3.game.queue.push('checkplayers');
            return 1;
          }
          _this3.halted = 1;
          _this3.resetGameWithFewerPlayers();
          return 0;
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'PLAYERS') {
          console.log('GTT: PLAYERS:', JSON.parse(JSON.stringify(_this3.toJoin)), JSON.parse(JSON.stringify(_this3.joining)));
          var change = _this3.toLeave.length + _this3.toJoin.length > 0;
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          if (change) {
            var player_to_send = 0;
            for (var i = 0; i < _this3.game.players.length; i++) {
              if (!_this3.toLeave.includes(_this3.game.players[i])) {
                player_to_send = i + 1;
                break;
              }
            }

            //Player one handles the move
            if (_this3.game.player == player_to_send) {
              var player_count = _this3.game.players.length;
              _this3.addMove('RESTARTGAME');
              var _iterator = _createForOfIteratorHelper(_this3.toLeave),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _pkey = _step.value;
                  if (_this3.game.players.includes(_pkey)) {
                    _this3.addMove("REMOVEPLAYER\t".concat(_pkey));
                    player_count--;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              for (var _i = 0; _i < _this3.toJoin.length && player_count++ < _this3.maxPlayers; _i++) {
                var pkey = _this3.toJoin[_i];
                _this3.addMove("ADDPLAYER\t".concat(pkey));
              }
              _this3.endTurn();
            }
            return 0;
          }
        }
        return 1;
      });
    }
  }]);
}(GameTemplate);
module.exports = GameTableTemplate;